const route = {
	name: 'profile',
	path: 'profile',
	component: () => import('@/pages/user/page-user'),
	meta: {
		title: 'Perfil',
		logo: '/static/img/sidebar/users.svg',
	},
	children: [
		{
			name: 'profile-edit',
			path: 'edit',
			components: {
				profileEdit: () => import('@/pages/user/page-user-edit'),
			},
			meta: {
				title: 'Editar Perfil',
				logo: '/static/img/sidebar/users.svg',
			},
		},
		{
			name: 'password-edit',
			path: 'password',
			components: {
				passwordEdit: () => import('@/pages/user/page-password-edit'),
			},
			meta: {
				title: 'Contraseña',
				logo: '/static/img/sidebar/users.svg',
			},
		},
	],
};
export default route;



// WEBPACK FOOTER //
// ./src/router/user/index.js